import Image from 'next/image';
import { FormattedMessage, useIntl } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import Heading from '@alltrails/denali/components/Heading';
import giftCard from '@/assets/images/at_gift_2025_logo.avif';
import styles from './GiftValuePanel.module.scss';
import perfectAvifSrc from './perfect.avif';

// https://www.figma.com/file/gZaqAej8HzoFkyrjlQ4cNs/Integrating-Brand-Changes?node-id=586%3A30927

const blurbs = [
  {
    heading: <FormattedMessage defaultMessage="Quick and easy" />,
    text: <FormattedMessage defaultMessage="Purchase a gift subscription easily. It arrives in moments and we notify you of delivery." />
  },
  {
    heading: <FormattedMessage defaultMessage="Customizable" />,
    text: <FormattedMessage defaultMessage="Choose a design you love and personalize a message." />
  },
  {
    heading: <FormattedMessage defaultMessage="Send via email or print" />,
    text: <FormattedMessage defaultMessage="Choose the delivery date the gift subscription will be emailed. Or, print and hand-deliver." />
  }
];

const br = () => <br />;

const GiftValuePanel = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <section>
        <div className={styles.give}>
          <Heading as="h2" size="600">
            <FormattedMessage defaultMessage="An easy way to give joy" />
          </Heading>
          <Typography component="div" variant="text200">
            <FormattedMessage defaultMessage="Send the gift of exploration to your friends and family with an AllTrails subscription." />
          </Typography>
        </div>
        <div className={styles.imageAndBlurbs}>
          <div className={styles.giftImageWrapper}>
            <Image alt={intl.formatMessage({ defaultMessage: 'AllTrails gift subscription' })} className={styles.img} src={giftCard} />
          </div>
          <div className={styles.blurbs}>
            {blurbs.map((blurb, index) => (
              <div className={styles.blurb} key={index}>
                <Heading as="h3" size="400">
                  {blurb.heading}
                </Heading>
                <Typography component="div" variant="text200">
                  {blurb.text}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={styles.perfectForAllContainer}>
        <div className={styles.perfect}>
          <Heading as="h2" size="600">
            <FormattedMessage defaultMessage="Perfect for all occasions and<br></br> outdoor enthusiasts." values={{ br }} />
          </Heading>
          <Typography component="div" variant="text200">
            <FormattedMessage defaultMessage="Celebrate the people you appreciate on birthdays, holidays, graduations and more. With the ability to browse by activity, it’s a fitting gift for any type of outdoor explorer in your life." />
          </Typography>
        </div>
        <Image
          alt={intl.formatMessage({
            defaultMessage:
              'Various individuals and groups enjoy different activities in nature: a backpacker steps forward with a smile, a family walks leisurely through a pine forest, and a cyclist begins their ascent up a lush mountain road.'
          })}
          className={styles.img}
          src={perfectAvifSrc}
        />
      </section>
    </div>
  );
};

export default GiftValuePanel;
